{
  "title": "Nodes",
  "add": "Add a node",
  "filter": "filter",
  "filterAria": "Filter by name or address",
  "filterEmpty": "Nothing matches the filter",
  "filterEmptyHint": "Loosen the condition: clear the status filter or empty the search box.",
  "emptyTitle": "This site has no nodes yet",
  "emptyHint": "A node is a device the platform checks and connects to: a server, a camera, a switch, a workstation. Add the first one and give it an availability monitor.",
  "noSitesHint": "Nodes belong to a site, and its agent runs the monitors. Create a site under Sites, then install an agent on it.",
  "loadFailed": "Could not load the nodes",
  "loadFailedHint": "{{reason}} Check the connection to the server.",
  "deleteAria": "Delete node {{name}}",
  "deleteTitle": "Delete the node",
  "deleteConfirm": "Delete node “{{name}}”? Its monitors will be turned off.",
  "noMonitor": "no monitor set",
  "pickNode": "Pick a node to see its monitors.",
  "shownOf": "showing {{shown}} of {{total}}",
  "liveOn": "statuses update in real time",
  "liveOff": "no connection",
  "statusFilter": "{{status}}: {{count}}",
  "monitorsCount_one": "{{count}} monitor",
  "monitorsCount_other": "{{count}} monitors",
  "linksCount_one": "{{count}} link",
  "linksCount_other": "{{count}} links",
  "column": {
    "rtt": "RTT, ms"
  },
  "summary": {
    "warn": "{{monitors}} · some are failing",
    "down": "{{monitors}} · not answering",
    "unknown": "{{monitors}} · no checks yet"
  },
  "status": {
    "up": "Up",
    "down": "Down",
    "warn": "Some checks are failing",
    "unknown": "State unknown"
  },
  "live": {
    "on": "Statuses arrive over WebSocket",
    "off": "No status subscription: the last known values are shown",
    "active": "Subscription active",
    "lost": "Subscription lost",
    "offline": "offline"
  },
  "kind": {
    "pc": "PC",
    "server": "server",
    "cloud": "cloud server",
    "camera": "camera",
    "nvr": "video recorder",
    "switch": "switch",
    "router": "router",
    "printer": "printer",
    "ap": "access point",
    "nas": "storage",
    "ups": "UPS",
    "phone": "phone",
    "label": "label",
    "other": "other"
  },
  "field": {
    "name": "Name",
    "address": "Address",
    "kind": "Type",
    "group": "Group",
    "noGroup": "no group",
    "layer": "Layer",
    "notes": "Notes"
  },
  "form": {
    "name": "Node name",
    "addressHint": "empty — monitors will need their target set by hand",
    "addressPlaceholder": "IP or host name",
    "layerAria": "Node layer",
    "layerHint": "The map layer the node is drawn on",
    "layerFromFrame": "The node sits in a frame and moves to the layer together with it",
    "layerHidden": "{{name}} · hidden",
    "movesWithFrame": "the node moves together with its frame",
    "layerIsHidden": "this layer is hidden right now — the node will not be visible",
    "notesPlaceholder": "what matters about this node"
  },
  "linkPoints": {
    "title": "Link points",
    "hint": "How many places on each side a link can attach to. Points are spread evenly along the side.",
    "sideAria": "Link points: {{side}}",
    "warning": "Fewer points than needed: {{links}} will be left without an attachment point and deleted.",
    "question": "{{links}} will lose their attachment point and be deleted for good. Save?"
  },
  "side": {
    "top": "top",
    "right": "right",
    "bottom": "bottom",
    "left": "left"
  },
  "metadata": {
    "title": "Metadata",
    "key": "field",
    "value": "value",
    "keyAria": "Name of field {{index}}",
    "valueAria": "Value of field {{index}}",
    "pinAria": "Show field {{index}} on the map",
    "deleteAria": "Delete field {{index}}",
    "add": "Add a field",
    "pinHint": "the checkbox shows the field on the map, at most {{limit}}",
    "onMap": "on the map"
  },
  "agentWarn": {
    "offlineTitle": "The site agent is not connected",
    "missingTitle": "The site has no agent",
    "offlineText": "Checks are run by the site agent, and it is not connected right now: the monitors exist but nobody runs them. Check the netdeck-agent service under Agents.",
    "missingText": "Checks are run by an agent installed at the site. Until there is one, nodes stay in the “unknown” state. Add an agent under Agents and run its install command on any machine in that network."
  },
  "addresses": {
    "title": "Additional IP addresses",
    "empty": "No additional addresses",
    "add": "Add address",
    "hint": "A single address or a range: 192.168.0.4 or 192.168.0.100 - 192.168.0.109",
    "placeholder": "192.168.0.100 - 192.168.0.109",
    "invalid": "Cannot parse: enter an address or a range separated by a dash",
    "inherits": "Checked the same way as the primary monitor of the node",
    "total": "{{total}} of {{max}} in total",
    "tooMany": "A node holds at most {{max}} additional addresses",
    "responding": "{{responding}} of {{total}} responding",
    "strip": "Additional addresses: {{responding}} of {{total}} responding",
    "rowAria": "Address or range, row {{index}}",
    "deleteAria": "Remove row {{index}}",
    "more": "+{{count}}",
    "moreTitle": "{{count}} more additional addresses",
    "state": {
      "up": "responding",
      "down": "not responding",
      "unknown": "not checked yet"
    }
  },
  "addressesCount_one": "{{count}} address",
  "addressesCount_other": "{{count}} addresses"
}
